// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "b16f548a",
    "hash": "b16f548a",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "b16f548a",
    "semverString": null,
    "version": "2026.8.0.3"
};
/* tslint:enable */
